export default "__VITE_ASSET__BZzDm25H__"